import * as React from 'react';
import { useState, useEffect, useCallback, useRef } from "react";
import PropTypes from 'prop-types';

import SaveIcon from '@mui/icons-material/Save';

import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputBase from '@mui/material/InputBase';
import { TextField, Button, FormControl, makeStyles } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";


import ConfigurationViewService from '../../services/configurationview.service';
import RecipeService from '../../services/recipe.service';
import AuditTrailViewService from '../../services/audittrailview.service';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};


function SaveChangesDialog(props) {

  const [open, setOpen] = useState(false);
  const [wrongValue, setWrongValue] = useState(false);

  const [message, setMessage] = useState();

  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openFaildialog, setOpenFaildialog] = useState(false);

  const [saveData, setSaveData] = useState(false);

  const[tagNamesInWriteConfig, setTagNamesInWriteConfig] = React.useState([]);
  const [openRemarkBlnkMsg, setOpenRemarkBlnkMsg] = useState(false);
  const [password, setPassword] = useState('');

  // get all data from writeconfig collection
  useEffect(() =>{

    async function getAllRowsData()  {
      try {

        let dashboardName = "WriteConfig"

        const response = await ConfigurationViewService.getAllRowsData(dashboardName);
        if (response){
          setTagNamesInWriteConfig(response.data.map((item) => item.TagName)); 
          //console.log(response.data);
        }
        
        
      } catch (error) {
        console.log(error);

      }
    };
    getAllRowsData();


  }, []);

  const handleClickSaveChanges = () => { 
    setSaveData(true);
  };

  const handleClose = () => {
    setOpen(false);
    setWrongValue(false);
    setOpenRemarkBlnkMsg(false);
  };

  const handleSuccessClose = () => {
    setOpenSuccessDialog(false);
    props.success(true);
  };

  const handleFailedClose = () => {
    setOpenFaildialog(false);
  };


  const [writeInProgress, setWriteInProgress] = useState(false);
  const [writeHiHiInProgress, setWriteHiHiInProgress] = useState(false);
  const [writeHighInProgress, setWriteHighInProgress] = useState(false);
  const [writeLowInProgress, setWriteLowInProgress] = useState(false);
  const [writeLoLoInProgress, setWriteLoLoInProgress] = useState(false);

  const [ReadRequest, setReadRequest] = useState(false);

  const isMounted = useRef(true); // Track if the component is mounted
  
  // Update RecipeView collection 
  useEffect(() =>{
    async function saveRowData()  {
    try {
      //console.log(props.writeData);
      let dashboardName = "RecipeView";
      let rowData = {
        _id: props.writeData._id,
        RecipeValue: props.recipeSetpoint,
      
        PWDInterlock: props.writeData.PWDInterlock,
        PWD: password,
        email: props.writeData.email,
        role: props.writeData.role
      }

      let auditTrailData = []

      const response = await RecipeService.updateRowData(dashboardName, rowData, auditTrailData);
      if(response){
        //console.log(response.data)
        setOpenSuccessDialog(true);
        setMessage("Updated parameter successively. ");
        //setOpen(false);
        
          
      }

    } catch (error) {
      setOpenSuccessDialog(false);
      setOpenFaildialog(true);
      setMessage("Error while editing recipe value, Please very all parameters, password entered in the form or server is down ");
      setOpen(false); // Close "Save changes" window
      //console.log(error);
    }
  };
  if(saveData){
    
    saveRowData();
    setSaveData(false);
  };


  }, [saveData]);
  
  // Check Remark and value change happened or not, then after only proceeed to open dialog of save changes
  const handleClickOpen = () => {
    // If remark field is blank then opern messagebox
    if(((props.writeData.RemarkStatus === "Enabled") && (props.writeData.Remark === "--")) || ((props.writeData.RemarkStatus === "Enabled") && (props.writeData.Remark === ""))){
      setOpenRemarkBlnkMsg(true);
    }else{
      //If no value change observed for Process value then open message box
        if(props.writeData.RecipeValue === props.recipeSetpoint){
          setOpenSuccessDialog(false);
          setOpenFaildialog(true);
          setMessage("There is no change observed in parameter value.");
          setOpen(false); // Close "Save changes" window

        }else{
          //If remoark is entered and value change observed then proceed
          setOpen(true);    
        }

    }
    

  }

  return (
    
    <div>
      <Button variant="outlined" startIcon ={<SaveIcon/>} sx={{mt:1}} onClick={handleClickOpen}>SAVE CHANGES </Button>

      {/* Open Remark Field is blank dialog box */}
      <Dialog open={openRemarkBlnkMsg} onClose={handleClose}>
        <DialogTitle>Enter Remark Field</DialogTitle>
        <Box sx={{width: 450 }}>
        <DialogContent dividers>
          <DialogContentText>
              Enter Remark into remark field to proceed further.
              <br />
              (Note: blank or '--' Value for remark field is not acceptable)
          </DialogContentText>
          
        </DialogContent>
        </Box>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Open Confirmation dialog box with or without password entry */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Save changes in value of parameter</DialogTitle>
        <Box sx={{width: 400 }}>
          <DialogContent dividers>
            <DialogContentText>
              Are you sure to update the Changes?.
            </DialogContentText>
            
          </DialogContent>

          {props.writeData.PWDInterlock === 'Enabled' && (<DialogContent dividers>
            <DialogContentText>
              Enter the Password to make changes in parameter value.
            </DialogContentText>
            <TextField
              //autoFocus
              margin="dense"
              id="Password"
              label="Password"
              type="password"
              fullWidth
              variant="standard"
              onChange={(event) => {
                setPassword(event.target.value);
              }}
            />

          </DialogContent>
          )}

        </Box>
        <DialogActions>
          <Button onClick={handleClickSaveChanges}>Save</Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Open wrong value enetered dialog box*/}
      <Dialog open={wrongValue} onClose={handleClose}>
        <DialogTitle>Wrong Value</DialogTitle>
        <Box sx={{width: 400 }}>
        <DialogContent dividers>
          <DialogContentText>
            Wrong Value or data entered. Please Correct it.
          </DialogContentText>
          
        </DialogContent>
        </Box>
        <DialogActions>
          <Button onClick={handleClose}>ok</Button>
        </DialogActions>
      </Dialog>

      {/* Success dialog after upgradtion of the parameter */}
      <Dialog
        open={openSuccessDialog}
        onClose={handleSuccessClose}
       
      >
        <DialogTitle > success.. </DialogTitle>
        <DialogContent>
          <DialogContentText>
            { message } 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessClose}>Close</Button>
        </DialogActions>
      </Dialog>

     
      {/* Save Changes Failed dialog /Wrong Password */}
      <Dialog
        open={openFaildialog}
        onClose={handleFailedClose}
       
      >
        <DialogTitle > Failed.. </DialogTitle>
        <DialogContent>
          <DialogContentText>
            { message } 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFailedClose}>Close</Button>
        </DialogActions>
      </Dialog>


    </div>
  );
}

export default function DashboardEdit ({params, open, close}) {
  //console.log(params)
  const { user } = useSelector((state) => state.auth);

  const initialWriteData = {
    _id:params.row._id,

    ProjectName: params.row.ProjectName,
    DashboardType: params.row.DashboardType,
    WidgetName: params.row.WidgetName,
    ParameterName:params.row.ParameterName,
    ParameterUnit:params.row.ParameterUnit,
    RecipeValue:params.row.RecipeValue,
    TagName: params.row.TagName,
    
    role:user.role,
    email: user.email,  
    RemarkStatus : "Disabled",
    Remark:"",
    EventStatus:"Disabled",
    PWDInterlock:"Disabled",
    PWD:""

  };

  const [writeData, setWriteData] = React.useState(initialWriteData);
 
  const[recipeSetpoint, setRecipeSetpoint] = React.useState('');

  // Get AuditTrail Configuration data for Remark field, either it is enabled or disabled
  useEffect(() =>{
    async function auditTrailConfigData()  {
    try {

      let dashboardName = 'AuditTrailConfig';
      let columnName = 'EventName';
      let columnValue = 'Setpoint Change';
      let response = await AuditTrailViewService.getColumnData(dashboardName, columnName, columnValue);

      
      if(response.data.length > 0){
        //console.log(response.data[0]);
        setWriteData(prev => ({
          ...prev,
          RemarkStatus:response.data[0].EnableRemark, 
          EventStatus: response.data[0].EnableEvent, 
          PWDInterlock: response.data[0].EnablePwdInterlock
        }));
      }
  
    } catch (error) {
      console.log(error);

    }
  }

  auditTrailConfigData();

  }, []);


  const handleSetpointValueChange = (event) => {
    const {name, value} = event.target;

     //   /^\d*\.?\d{0,7}$/.test(value))
    const regex = new RegExp( `^-?\\d{0,5}(?:\\.\\d{0,3})?$` );

    // Validate input against the dynamic regex
    if (regex.test(value)) {
      setRecipeSetpoint(value);

      //setWriteData({...writeData, [name]:value});
      
    }

  };


  const handleRemarkChange = (event) => {
    const {name, value} = event.target;
    setWriteData({...writeData, [name]:value});

  };

  const handleClose = () => {
    //console.log("Close Buton Pressed");
    close() // Close the alarm add main window
  };

  const handleRecordSaveSuccess = (data) =>{
    close(data)
  }
  
  return (
    <div>
      <BootstrapDialog
        onClose={close}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          style: {
            maxWidth: '1000px', // Change this value as needed
          },
        }}
      >
        {/* Hnadle multiple functions on single click ie edit switch set to false and close the MyAccount Dialog */}
        <BootstrapDialogTitle id="customized-dialog-title" onClose={() => {handleClose();  }}>
          Edit parameter value.
        </BootstrapDialogTitle>

        {/*Setpoint Changes*/}
        <DialogContent dividers>
          {/*
          <Typography gutterBottom sx={{ mt: 0, mb:3, width: 200 }}>
          {params.row.TagDescription1}
          </Typography>
          */}

          {/* Parameter Name */}
          <TextField
            sx={{ m: 0, width: 200, mt: 1, mr:2, }}
            margin="dense"
            label="Parameter Name"
            //type="number"
            //fullWidth
            variant="standard"
            name="ParameterName"
            value={params.row.ParameterName}
            disabled={true}
          />

          {/* Present Value */}
          <TextField
            sx={{ m: 0, width: 200, mt: 1, mr:2, }}
            margin="dense"
            label="Present Value"
            //type="number"
            //fullWidth
            variant="standard"
            name="RecipeValue"
            value={params.row.RecipeValue}
            disabled={true}
          />

          {/* Set Value */}
          <TextField
            margin="dense"
            label="Set Value"
            //type="number"
            //fullWidth
            variant="standard"
            name="RecipeValue"
            value={recipeSetpoint}
            onChange={handleSetpointValueChange}
            disabled={false}
          />

          
        </DialogContent>

        {/*Remark */}
        {writeData.RemarkStatus === 'Enabled' && (<DialogContent 
        dividers
        >
          <Typography gutterBottom sx={{ mt: 0, mb:3, width: 400 }}>
          Enter remark for parameter value change 
          </Typography>

          <TextField
            id="outlined-multiline-static"
            label="Remark"
            name="Remark"
            placeholder="Enter Remark"
            multiline
            rows={4}
            style={{ width: 400 }}
            onChange={handleRemarkChange}
            //defaultValue="Default Value"
          />

        </DialogContent>
        )}

        <DialogActions>
          <SaveChangesDialog
          writeData = {writeData}
          recipeSetpoint = {recipeSetpoint}

          success = {handleRecordSaveSuccess}
          />
        </DialogActions>
        
      </BootstrapDialog>
    </div>
  );
}

